import { STORE_SUPPORT_ITEMS, STORE_CURRENT_SUPPORT_ITEM, STORE_AND_PROCESS_SUPPORT, SET_SUPPORT_STATE, SET_SUPPORT_STATE_JUST_OPENED, SET_SUPPORT_STATE_BY_INDEX, SET_SUPPORT_VISIBLE, STORE_CURRENT_COMMENT_ITEM, SET_SUPPORT_STATE_NEXT, SET_SUPPORT_STATE_PREV, STORE_CURRENT_NOTES_ITEM } from '../constants/actionConstants';

// support -- the support item that we are editing, or the support items for this content
// supportItems -- all of the support items in the database (for editing)

const SupportReducer =  (state = {  support: {name:undefined, title:undefined, keywords:[], content:[]},  // Current displayed support item
                                    comment: {comment_id:undefined, content_id:undefined},
                                    note: {note_id: undefined, content_id:undefined},
                                    supportItems: [],                                                     // All the support items
                                    supportItemsHistory: [],                                              // List of IDs in recent history
                                    supportItemHistoryIndex: -1,                                           // Where we are in the index 
                                    keywordMap:[], 
                                    visible: false  }, action) =>{
    switch(action.type)
    {
        // Sets the current open comment
        case STORE_CURRENT_COMMENT_ITEM:
            // If we are opening comment then open right hand panel
            if(action.payload.comment_id!==undefined){
                return {...state,  comment: action.payload, visible: true}
            }
            // If removing comment then make no difference to right hand panel
            else{
                return {...state,  comment: action.payload}
            }
        // Sets the current open comment
        case STORE_CURRENT_NOTES_ITEM:
            // If we are opening comment then open right hand panel
            if(action.payload.comment_id!==undefined){
                return {...state,  note: action.payload, visible: true}
            }
            // If removing comment then make no difference to right hand panel
            else{
                return {...state,  note: action.payload}
            }



        // Sets the support panel to visible or not when very small screen
        case SET_SUPPORT_VISIBLE:
            return {
                ...state, visible:action.payload 
            }
        // Stores all support items in database if in edit mode, or all current support items if in learn mode
        case STORE_SUPPORT_ITEMS:
            console.log(action.payload)
            return {...state, 
                supportItems: action.payload,
            }
        // Stores the current support item that is being edited
        case STORE_CURRENT_SUPPORT_ITEM:
            return {...state, 
                support: action.payload,
            }
        // Update current support item 
        case STORE_AND_PROCESS_SUPPORT:
            let keywordMap = []
            // // Store mapping between keywords and support index
            action.payload.support.forEach((support_item, support_index)=>{
                if((support_item?.title ?? '').length > 0 ){
                    keywordMap.push({keyword: support_item.title, index:support_index, title:true})
                }
                support_item.keywords.forEach((keyword) => {
                    if(keyword !== ''){
                        keywordMap.push({keyword: keyword, index:support_index, title:false})
                    }
                })
            })
            // Sort so that they are in alphabetical order
            keywordMap = keywordMap.sort((a, b) => a.keyword.localeCompare(b.keyword));
            const all_support = [...action.payload.support, ...action.payload.references]
            return {...state,  supportItems: all_support, keywordMap:keywordMap}
        
        // Called from links
        case SET_SUPPORT_STATE:
            // Receives ID -- now retrieve support items
            let index = state.supportItems.findIndex(el => el._id === action.payload);
            // If we found the index 
            if(index!==-1 ){
                // Add to history
                let supportItemsHistoryCopy = structuredClone(state.supportItemsHistory)
                // If we are not at the end of the history, then truncate the history
                if(state.supportItemHistoryIndex < state.supportItemsHistory.length-1){
                    supportItemsHistoryCopy.length = state.supportItemHistoryIndex+1
                }
                
                 // Don't add to history if it is the last item already
                if(supportItemsHistoryCopy.length===0 || (supportItemsHistoryCopy.length> 0 && (supportItemsHistoryCopy[supportItemsHistoryCopy.length-1] !== state.supportItems[index]._id))){
                    supportItemsHistoryCopy.push(state.supportItems[index]._id)
                }
                // supportItemsHistoryCopy.push(state.supportItems[index]._id)
                return {...state, support: state.supportItems[index], supportItemsHistory: supportItemsHistoryCopy, supportItemHistoryIndex: supportItemsHistoryCopy.length-1, visible: true}
            }
            else{
                return {...state, support: {name:undefined, title:undefined, keywords:[], content:[]}, 
                                  supportItemsHistory: [],
                                  supportItemHistoryIndex: -1}
            }
        // Called from dropdown menu
        case SET_SUPPORT_STATE_BY_INDEX:
            let supportItemsHistoryCopy = structuredClone(state.supportItemsHistory)
             // If we are not at the end of the history, then truncate the history
            if(state.supportItemHistoryIndex < state.supportItemsHistory.length-1){
                supportItemsHistoryCopy.length = state.supportItemHistoryIndex+1
            }
            // Don't add to history if it is the last item already
            if(supportItemsHistoryCopy.length===0|| (supportItemsHistoryCopy.length> 0 && (supportItemsHistoryCopy[supportItemsHistoryCopy.length-1] !== state.supportItems[action.payload]._id))){
                supportItemsHistoryCopy.push(state.supportItems[action.payload]._id)
            }
            return {...state, support: state.supportItems[action.payload], supportItemsHistory: supportItemsHistoryCopy, supportItemHistoryIndex: supportItemsHistoryCopy.length-1, visible:true }

        case SET_SUPPORT_STATE_JUST_OPENED:
            return {...state, supportStateJustOpened: action.payload.supportStateJustOpened}
        default:
            return state ; 

        case  SET_SUPPORT_STATE_NEXT:
            let index_next = state.supportItems.findIndex(el => el._id === state.supportItemsHistory[state.supportItemHistoryIndex+1]);           
            return{...state, support: state.supportItems[index_next], supportItemHistoryIndex: state.supportItemHistoryIndex+1}
        case  SET_SUPPORT_STATE_PREV: 
            let index_prev = state.supportItems.findIndex(el => el._id === state.supportItemsHistory[state.supportItemHistoryIndex-1]);           
            return{...state, support: state.supportItems[index_prev], supportItemHistoryIndex: state.supportItemHistoryIndex-1}
        
    }
} ; 

export default SupportReducer 

